import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const RegistrationModal = ({ isOpen, onClose }) => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRegister = async (e) => {
    e.preventDefault(); // Prevents the page from refreshing
    setLoading(true);

    // Prepare the data payload
    const apiAddress = process.env.REACT_APP_SECRET || "https://localhost:7175";

    const payload = {
      id: "F07294B7-C94D-4D5E-A064-B1282D5B5532",
      companyLegalName: "",
      address: "",
      companyRegistrationNumber: "",
      businessTypeId: "Home Cook",
      firstName: firstname,
      surName: lastname,
      phoneNumberCountryCode: "GB",
      phoneNumber: phoneNumber,
      email: email,
      webSiteAddress: "",
      uploadedDocImagePath: "",
      approvalStatusId: "f07294b7-c94d-4d5e-a064-b1282d5b5434", // Approved
    };

    // Send the API Request
    try {
      const url = `${apiAddress}/api/RestaurantRegistration`;
      const response = await axios.post(url, payload);

      if (
        response.data === "OK" ||
        response.data === "Registration successfully."
      ) {
        toast.success("Registration Successful!");
        // Clear form
        setFirstname("");
        setLastname("");
        setEmail("");
        setPhoneNumber("");
      } else {
        toast.error(response.data || "Registration failed.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="hc-modal-overlay" onClick={onClose}>
      <div className="hc-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="hc-close-btn" onClick={onClose}>
          ×
        </button>

        <h3 style={{ marginBottom: "10px", textAlign: "center" }}>
          Begin Your Expansion
        </h3>
        <p
          style={{
            textAlign: "center",
            color: "#8a8580",
            marginBottom: "20px",
            fontSize: "0.9rem",
          }}
        >
          Create your chef profile in seconds.
        </p>

        <form onSubmit={handleRegister}>
          <input
            type="text"
            placeholder="First Name"
            className="hc-input"
            value={firstname}
            onChange={(e) => setFirstname(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Last Name"
            className="hc-input"
            value={lastname}
            onChange={(e) => setLastname(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="Email Address"
            className="hc-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="tel"
            placeholder="Phone Number"
            className="hc-input"
            inputMode="numeric"
            value={phoneNumber}
            maxLength={15}
            onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, ""))}
            required
          />
          <button
            className="hc-btn hc-btn-dark hc-btn-block text-uppercase"
            type="submit"
            disabled={loading}
          >
            {loading ? "Processing..." : "Register Now"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default RegistrationModal;
